/* import __COLOCATED_TEMPLATE__ from './nav-home-logo-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();